import React, { useMemo } from "react";
import moment from "moment";
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  Box,
  Button,
} from "@mui/material";
import { StyledTableCell, StyledTableRow } from "../utils";
import { Editedtext } from "../CommonComps/TextTemplate";
import { DataStatus } from "../CommonComps/DataStatus";
import CommonPagination from "../CommonComps/CommonPagination";
import AmountInfo from "../CommonComps/AmountInfo";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { themecolor } from "../Navigation";

const isNumeric = (value) => !isNaN(value) && isFinite(value);

const formatDate = (dateString) => {
  const date = moment(dateString);
  return date.isValid() ? date.format("DD-MM-YYYY hh:mm A") : "-";
};

const StyledRowSpanCell = ({ row, value, rowSpan, align = "center" }) => (
  <StyledTableCell
    rowSpan={rowSpan}
    sx={{
      textAlign: align,
      paddingLeft: 0,
      height: "auto",
      width: 200,
      fontWeight: "bold",
      // borderLeft: "1px solid rgb(224, 224, 224)",
      borderLeft: "1px solid black",
      backgroundColor: row?.backgroundColor,
    }}
  >
    {isNumeric(value) ? <AmountInfo amount={parseFloat(value) || 0} /> : value}
  </StyledTableCell>
);

const calculateRowSpan = (filteredData) => {
  const rowSpanMapping = {};
  let count = 0;
  let prevStatus = null;

  filteredData.forEach((row, index) => {
    if (row.tabMessage !== prevStatus) {
      count = 1;
      prevStatus = row.tabMessage;
    } else {
      count += 1;
    }
    rowSpanMapping[index] = count;
  });

  return rowSpanMapping;
};

const Row = ({ key, row, header, tabStatus, parentIndex, spanCol }) => {
  return (
    <StyledTableRow
      style={{ backgroundColor: row?.backgroundColor, height: "6vh" }}
    >
      {header?.map((item, index) => {
        if (!item.isShow) return null;

        const isMatchStatus = item.alias === "tabMessage";
        const shouldRender =
          tabStatus === "TOTAL"
            ? true
            : isMatchStatus
            ? parentIndex === 0
            : true;

        return shouldRender ? (
          isMatchStatus && tabStatus !== "TOTAL" && parentIndex === 0 ? (
            <StyledRowSpanCell
              key={key}
              value={row[item.alias] || "-"}
              rowSpan={spanCol}
              row={row}
            />
          ) : (
            <StyledTableCell
              key={key}
              size="small"
              sx={{
                textAlign: item.textAlign || "start",
                paddingLeft: item.alias === "SNO" ? "10px !important" : 0,
                height: "auto",
                width: item.name === "S.NO" ? 94 : 200,
                borderBottom: "1px solid black",
                borderLeft: "1px solid black",
                fontWeight: item.name === "Remark" ? 500 : null,
              }}
            >
              {item.alias === "SNO" ? (
                parentIndex + 1
              ) : isNumeric(row[item.alias]) ? (
                <AmountInfo
                  amount={parseFloat(row[item.alias]) || "0"}
                  calculate={true}
                />
              ) : (
                <Editedtext text={row[item.alias] || "-"} />
              )}
            </StyledTableCell>
          )
        ) : null;
      })}
    </StyledTableRow>
  );
};

export default function ReconciliationTable({
  headerConfig,
  data = [],
  pageNo,
  setPageNo,
  totalPages,
  setTotalPages,
  setPageSize,
  pageSize,
  tabStatus,
  navigate,
}) {
  const onPageChange = (_, value) => setPageNo(value);

  const filteredData = useMemo(() => {
    return tabStatus === "TOTAL"
      ? data
      : data.filter((row) => row.tabStatus === tabStatus);
  }, [tabStatus, data]);

  const rowSpanMapping = useMemo(
    () => calculateRowSpan(filteredData),
    [filteredData]
  );

  console.log(filteredData, "bajsk");

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          marginTop: 2,
          height:
            // tabStatus !== "TOTAL" && data.length < 25
            //   ? `${data?.length}`
            //   :
            "60vh",
          overflowX: "auto",
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <StyledTableRow>
              {headerConfig.map(
                ({ name, id, isShow, textAlign }, columnIndex) =>
                  isShow ? (
                    <StyledTableCell
                      key={id || columnIndex}
                      sx={{
                        minWidth: name === "S.NO" ? 94 : 200,
                        textAlign: textAlign || "start",
                        padding:
                          name === "S.NO" ? "0px 10px !important" : "auto",
                        height: "auto",
                      }}
                    >
                      {name}
                    </StyledTableCell>
                  ) : null
              )}
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {filteredData.length > 0 ? (
              filteredData.map((row, index) => (
                <Row
                  key={index}
                  row={row}
                  parentIndex={index}
                  header={headerConfig}
                  tabStatus={tabStatus}
                  spanCol={tabStatus !== "TOTAL" ? filteredData.length : 1}
                  rowSpanMapping={rowSpanMapping}
                />
              ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={headerConfig.length + 1}>
                  <DataStatus />
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Button
          variant="outlined"
          style={{ padding: "5px", marginTop: "20px" }}
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
        {/* Added cursor for better UX */}
        {/* {filteredData.length > 0 && (
          <CommonPagination
            pageSize={pageSize}
            totalPages={totalPages}
            pageNo={pageNo}
            setPageNo={setPageNo}
            setPageSize={setPageSize}
            onPageChange={onPageChange}
            sx={{ minWidth: 200, mx: 2 }} // Used mx (margin horizontal) for cleaner styling
            label="GST's Report"
          />
        )} */}
      </Box>
    </>
  );
}
